// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__-pxOz","errors":"Errors_errors__26Reb"};